export const getUsageDensityPolygonData = async (vueInstance) => {
    let self = vueInstance;

    let results = (await self.$http.get(`${TELSA.apiHost}geomap/heatpolygons/${self.heatmapPolygonResultKey}`)).body;
    if(results.polygon_data.length) {
        self.heatmapPolygonData = results.polygon_data;
        self.heatmapPolygonResultKey = results.result_key;
    }
    if(self.usageDensityPolygonFetchInterval) {
        self.usageDensityPolygonFetchTimeout = setTimeout(() => {
            if(!self._isDestroyed) {
                getUsageDensityPolygonData(self);
            }
        }, self.usageDensityPolygonFetchInterval);
    }
};



export const buildUsageDensityPolygons = (vueInstance) => {
    let self = vueInstance;

    let newPolygonList = [];
    let sectorIds = [];
    for(let marker of self.usageDensityMarkers) {
        sectorIds = sectorIds.concat(marker.sectors.filter(s => s.draw_polygons).map(s => parseInt(s.sect_id)));
    }
    sectorIds = [...new Set(sectorIds)]; // Remove duplicates
    let usagePolygons = self.heatmapPolygonData.filter(hp => sectorIds.includes(hp.sect_id));

    // Remove all existing polygons
    self.usageDensityPolygons = [];
    self.usageDensityPolygonElements.forEach(x => x.setMap(null)); // removes the polygon from the DOM
    self.usageDensityPolygonElements = [];

    // Build list of new polygons
    for(let usagePolygon of usagePolygons) {
        let polygon = {
            id: usagePolygon.polygon_id,
            siteId: usagePolygon.site_id,
            sectorId: usagePolygon.sect_id,
            samples: usagePolygon.samples,
            innerBound: usagePolygon.inner_bound_km,
            outerBound: usagePolygon.outer_bound_km,
            polygonInfoPosition: usagePolygon.polygon_info_position,
        };
        self.usageDensityPolygons.push(polygon);

        let polygonOptions = {
            map: self.googleMapsObj,
            paths: google.maps.geometry.encoding.decodePath(usagePolygon.encoded_polygon),
            clickable: true,
            fillColor: '#FF0000', 
            fillOpacity: usagePolygon.opacity, 
            strokeWeight: 0.1,
            strokeOpacity: 0.3,
            visible: true
        };
        let polygonElement = new google.maps.Polygon(polygonOptions);
        polygonElement.addListener('click', (e) => {
            self.selectedUsageDensityPolygon = null;
            self.$nextTick(() => {
                self.selectedUsageDensityPolygon = polygon;
            });
        });
        polygonElement.addListener('mouseover', (e) => {
            polygonElement.setOptions({strokeWeight: 0.6, strokeOpacity: 0.9});
        });
        polygonElement.addListener('mouseout', (e) => {
            polygonElement.setOptions({strokeWeight: 0.1, strokeOpacity: 0.3});
        });
        self.usageDensityPolygonElements.push(polygonElement);
    }
};

